import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { WorkOvertimeApplicationsState } from '@/store/applications/workOvertime/types';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'

const WorkOvertimeApplications: Module<WorkOvertimeApplicationsState, RootState> = {
  state: () => ({
    applications: [],
    pager: {
      current: 1,
      last: 1,
      totalLength: 0,
    },
  }),
  mutations,
  actions,
  getters,
};

export default WorkOvertimeApplications
